import type { notes as Fr } from '../fr/notes';

/** « notes » in English — typed on the French: a missing sentence does not compile. */
export const notes: typeof Fr = {
  erreurChargement: 'The notes could not be loaded.',
  erreurEnregistrement: 'The note could not be saved.',
  neSAffichentPas: 'Notes cannot be displayed',
  titre: 'Notes',
  compte: (n: number) => `${n} ${n === 1 ? 'note' : 'notes'}`,
  vousEcrivez: ' · you write here',
  vousLisez: ' · written by the owner, you read them',
  ecrire: 'Write a note',
  rienNote: 'Nothing noted yet',
  responsableRien: 'The owner has not noted anything',
  nePlusEpingler: 'Unpin',
  epinglerEnHaut: 'Pin to top',
  epinglee: 'Pinned',
  epingler: 'Pin',
  modifier: 'Edit',
  supprimer: 'Delete',
  vide: '— empty —',
  modifieeLe: (d: string) => `edited on ${d}`,
  modifierNote: 'Edit note',
  titreChamp: 'Title',
  titreExemple: 'E.g. renegotiate the Medtrans rate',
  note: 'Note',
  noteExemple: 'What you do not want to forget.',
  annuler: 'Cancel',
  enregistrer: 'Save',
  supprimerTitre: (t: string) => `Delete “${t}”?`,
  supprimerTexte: 'The note disappears for good. The audit log will keep a record of the deletion, not the text.',
};
